/**
 * BLUF-1298 AC6 — shown when an authenticated user navigates to a
 * route their role cannot access. Provides a clear message and a link
 * back to their role-appropriate home page.
 */

import { Container, Card, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext.js';
import { homePathFor } from './home-path.js';

export function AccessDeniedPage() {
  const { role, activeRole, roleCatalogue } = useAuth();
  const navigate = useNavigate();

  // homePathFor returns '/' for null role, catalogue-miss, or absent
  // landing marker — so a null-role session naturally lands on the
  // public landing page. Use the effective role (activeRole ?? role)
  // so mid-session switchers get routed to their current role's home.
  const destination = homePathFor(activeRole ?? role, roleCatalogue);

  return (
    <Container className="py-5" style={{ maxWidth: 480 }}>
      <Card className="shadow-sm border-0 text-center">
        <Card.Body className="p-5">
          <h1 className="h4 mb-3">Access Denied</h1>
          <p className="text-secondary mb-4">
            Your role does not have permission to view this page.
          </p>
          <Button
            variant="primary"
            onClick={() => navigate(destination, { replace: true })}
          >
            Return to Home
          </Button>
        </Card.Body>
      </Card>
    </Container>
  );
}
